module.exports = __webpack_public_path__ + "static/img/btn.b344ae5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitefriends/newInvite/Slicing/btn.png
// module id = bIfp
// module chunks = 23